import VueImageZoomer from 'vue-image-zoomer';
import 'vue-image-zoomer/dist/style.css';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(VueImageZoomer);
});
